import React from 'react';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { ZohoInsertionOrder } from 'shared/src/domain/zoho/zoho-types';

type Props = {
  ios: ZohoInsertionOrder[];
  selected: ZohoInsertionOrder | null;
  setSelected: (io: ZohoInsertionOrder | null) => void;
};

export function InsertionOrderSelect({ ios, setSelected, selected }: Props) {
  return (
    <Listbox value={selected} onChange={setSelected}>
      <div className="relative mt-2">
        <ListboxButton className="outline-solid focus:outline-solid grid h-9 w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-2 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
          <span className="col-start-1 row-start-1 truncate pr-6">
            {selected ? (
              <Entry io={selected} />
            ) : (
              <div className="text-gray-600">Select Insertion Order</div>
            )}
          </span>
          <FontAwesomeIcon
            icon={faChevronDown}
            aria-hidden="true"
            className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
          />
        </ListboxButton>

        <ListboxOptions
          transition
          className="focus:outline-hidden data-closed:data-leave:opacity-0 data-leave:transition data-leave:duration-100 data-leave:ease-in absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 sm:text-sm">
          {ios.map(io => (
            <ListboxOption
              key={io.id}
              value={io}
              className="data-focus:bg-blue-50 data-focus:text-gray-800 data-focus:outline-hidden group relative cursor-default select-none p-2 text-sm text-gray-600">
              <Entry io={io} />
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
}

function Entry({ io }: { io: ZohoInsertionOrder }) {
  return (
    <div className="flex items-center">
      <span className="group-data-selected:font-semibold mr-1 w-[70px] font-semibold">
        {io.IO_Number.trim()}
      </span>
      <span className="group-data-selected:font-semibold flex-1  truncate font-normal">
        {io.Name}
      </span>
    </div>
  );
}
